export const u20BundesligaStart2025 = {
  "id": "u20-bundesliga-start-2025-26",
  "title": "U20-Bundesliga startet am 20. September – Berlin trifft auf Niedersachsen",
  "slug": "u20-bundesliga-start-berlin-niedersachsen-2025-26",
  "publishedAt": "2025-09-18T14:00:00Z",
  "author": "Rugby Bundesliga Redaktion",
  "language": "de",
  "readTime": "2 min",
  "tags": ["Rugby", "U20", "Bundesliga", "Saison 2025/26", "Berlin", "Niedersachsen", "Nachwuchs"],
  "excerpt": "Am 20. September startet die neue U20-Bundesliga mit dem Duell Berlin gegen Niedersachsen – als Vorspiel zur Bundesligapartie Berliner RC gegen TSV Handschuhsheim. Ein Rugbyfest für die Fans in der Hauptstadt.",
  "img": "/images/u20-bundesliga-start-2025-26.jpg",
  "blocks": [
    {
      "type": "paragraph",
      "content": "Am 20. September 2025 fällt der Startschuss für die U20-Bundesliga. Den Auftakt macht die Begegnung zwischen Berlin und Niedersachsen, die als Vorspiel zur Bundesligapartie zwischen dem Berliner RC und dem TSV Handschuhsheim ausgetragen wird. Damit bietet sich Rugbyfans in Berlin ein ganzer Nachmittag voller Spitzenrugby – von den Nachwuchstalenten bis hin zur 1. Bundesliga."
    },
    {
      "type": "paragraph",
      "content": "Die Gastgeber vom Berliner RC zeigten zum Saisonauftakt in der Bundesliga bereits eine engagierte Leistung. Zwar ging die Partie gegen den München RFC verloren, doch die Hauptstädter konnten das Spiel lange offen gestalten und haben bewiesen, dass sie in dieser Saison mit Kampfgeist und Disziplin auftreten."
    },
    {
      "type": "paragraph",
      "content": "Der TSV Handschuhsheim reist hingegen mit breiter Brust an die Spree. Nach einem deutlichen Sieg gegen die RG Heidelberg am ersten Spieltag haben die „Löwen“ eindrucksvoll demonstriert, dass sie auch nach einigen Abgängen in der Sommerpause weiterhin zu den Topteams der Liga gehören. Allerdings muss der TSV an diesem Wochenende auf mehrere Nationalspieler verzichten – ein Umstand, der dem Berliner RC die Tür zu einem möglichen Überraschungserfolg öffnen könnte."
    },
    {
      "type": "paragraph",
      "content": "Neben dem Kräftemessen der Bundesliga-Teams dürfen sich die Zuschauer besonders auf den Auftakt der U20-Bundesliga freuen. Das Duell Berlin gegen Niedersachsen verspricht ein packendes Spiel, in dem junge Talente zeigen können, dass sie schon jetzt auf höchstem Niveau mithalten. Für viele Spieler ist es eine wichtige Bühne, um sich für höhere Aufgaben zu empfehlen und erste Erfahrungen im Ligabetrieb zu sammeln."
    },
    {
      "type": "paragraph",
      "content": "Mit diesem Doppelspieltag erwartet die Fans in Berlin ein Rugbyfest, das sowohl die Zukunft als auch die Gegenwart des deutschen Rugbysports in den Mittelpunkt rückt."
    }
  ]
};
